export default "__VITE_ASSET__wDem4IMI__"